var exports = {
  "Qq": "x234b8571--a527f5--text",
  "X0": "x234b8571--a527f5--formatted",
};

module.exports = exports;
